import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
interface WaveWinnersDropHeaderAuthorHandleProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropHeaderAuthorHandle(t0) {
  const $ = _c(11);
  const {
    winner
  } = t0;
  const t1 = winner.drop.author.handle ?? winner.drop.author.id;
  const t2 = `/${winner.drop.author.handle}`;
  let t3;
  if ($[0] !== t2 || $[1] !== winner.drop.author.handle) {
    t3 = <Link href={t2} onClick={_temp} className="tw-no-underline tw-text-iron-200 tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-underline desktop-hover:hover:tw-text-opacity-80">{winner.drop.author.handle}</Link>;
    $[0] = t2;
    $[1] = winner.drop.author.handle;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <p className="tw-text-md tw-mb-0 tw-font-semibold tw-leading-none"><UserProfileTooltipWrapper user={t1}>{t3}</UserProfileTooltipWrapper></p>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== winner.drop.author.level) {
    t5 = <UserCICAndLevel level={winner.drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[6] = winner.drop.author.level;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(e) {
  return e.stopPropagation();
}